<template>
  <v-dialog v-model="dialog.show" max-width="700">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-list-item v-for="empresa in empresas" :key="empresa">
          <v-list-item-content>
            <v-list-item-title>{{ empresa }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Empresa from "@/services/empresa";

export default {
  name: "DialogListEmpresas",

  data() {
    return {
      dialog: {
        title: "Empresas",
        show: false,
        edit: false
      },
      empresas: [],
      serviceEmpresa: new Empresa()
    };
  },

  methods: {
    async show(empresas) {
      try {
        const response = await this.serviceEmpresa.getByCnpj(empresas);
        this.empresas = [];
        response.forEach(empresa => {
          this.empresas.push(empresa.nome);
        });
        console.log(response);
        this.dialog.show = true;
      } catch (error) {
        this.dialog.show = false;
        console.error(error);
        this.$toast.error("Erro ao buscar as empresas");
      }
    }
  }
};
</script>
